export default {
  title: {
    base: 'Why partner with Healistic',
    symbol: '',
    extra: '?',
  },
  cards: BENEFITS_CARDS,
};
